import { render } from "./LandingPageCSHealthInsurance.vue?vue&type=template&id=5a8f569a&scoped=true"
import script from "./LandingPageCSHealthInsurance.vue?vue&type=script&lang=js"
export * from "./LandingPageCSHealthInsurance.vue?vue&type=script&lang=js"

import "./LandingPageCSHealthInsurance.vue?vue&type=style&index=0&id=5a8f569a&scoped=true&lang=css"
import "./LandingPageCSHealthInsurance.vue?vue&type=style&index=1&id=5a8f569a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8f569a"]])

export default __exports__